var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var LegalEntityHeader = function (_a) {
    var entity = _a.entity;
    return (_jsx("div", __assign({ className: "info-block detail-info" }, { children: _jsxs("div", __assign({ className: "highlit-panel" }, { children: [_jsx("div", __assign({ className: "highlit-panel-icon" }, { children: _jsx("i", { className: "fa pull-left fa-building" }) })), _jsx("div", __assign({ className: "highlit-panel-title" }, { children: _jsx("span", { children: entity === null || entity === void 0 ? void 0 : entity.name }) }))] })) })));
};
export default LegalEntityHeader;
